import React, { useState } from "react";
import { GoogleMap, Marker, Polygon, withGoogleMap } from "react-google-maps";

interface IMapCenter {
  lat: number;
  lng: number;
}

const ItemMap = (): JSX.Element => {
    /** misc */
    const googleMap: GoogleMap = null;
    const mapBounds = {
        east: 0,
        north: 0,
        south: 0,
        west: 0,
    };
    const latArray: number[] = [];
    const lngArray: number[] = [];
    const item: any = null; /** point or polygon */
    const mapHeight = 32;
    const mapWidth = 32;
    const googleMapOptions: google.maps.MapOptions = {
        disableDefaultUI: true,
    };
    const defaultMapCenter = {
    // overwrite depending on object type
        lat: 0,
        lng: 0,
    };
    const polygonCoordinates: any[] = [];
    const markerIcon = null;
    const mapData = null;

    const [mapZoom, setMapZoom] = useState<number>(6);
    const [mapCenter, setMapCenter] = useState<IMapCenter>({
        lat: 32.7079,
        lng: -96.9209,
    });

    return (
        <GoogleMap
            defaultZoom={mapZoom}
            defaultCenter={mapCenter}
            options={googleMapOptions}
        >
            {mapData}
        </GoogleMap>
    );
};

export default withGoogleMap(ItemMap);
